import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'transflo-document-metadata',
  templateUrl: './document-metadata.component.html',
  styleUrl: './document-metadata.component.scss',
})

export class DocumentMetadataComponent {
  @Input() metadata: any[] = [];
  @Input() documentName: string = '';
  @Input() showPopup: boolean = false;
  @Input() eventId: number;
  @Output() close = new EventEmitter<void>();
  @Output() submit = new EventEmitter<any>();

  formData: any = {};

  ngOnInit() {
    // Sort the metadata array by the 'Order' field to control the display order
    this.metadata.sort((a, b) => (a.Order || 0) - (b.Order || 0));
  }

  closePopup(): void {
    this.close.emit();
  }

  submitForm(): void {
    const formFields = this.formData;
    this.redirectToMobileApp(formFields);
  }

  redirectToMobileApp(formFields: any): void {
    const fleetId = localStorage.getItem('fleetId');
    const token = localStorage.getItem('token');
    const appScheme = 'transflomobileplus';
    //http://localhost:4200/#/action-buttons?confnumber=584744441kdj&eventid=37&fleetId=TESTFLEET;token%3DYXNocmFmLmhvc2FtQHRyYW5zZmxvLmNvbTpTckZOYUNmSElnQ21qVzlPK2J1SFRwaGpvaTFJbzB3blZudzI4YklnWXNFeXlwcm9YWVB5WTZZV2Z6K21mTTYwT3pMTlJjVDJ1UlRFdkRXMFhwZG8rUT09
    const sourceApp = 'http://localhost:4200/#/action-buttons';
    let deepLinkUrl = `${appScheme}://scan?recipientid=${fleetId}`;

    for (const fieldName in formFields) {
      if (formFields.hasOwnProperty(fieldName)) {
        deepLinkUrl += `&${encodeURIComponent(fieldName)}=${encodeURIComponent(formFields[fieldName])}`;
      }
    }

    deepLinkUrl += `&return=confnumber&fleetId=${fleetId}&token=${token}&eventId=${this.eventId}&sourceapp=${sourceApp}`;
    console.log('deeplink: ', deepLinkUrl);
  }

}
